<template>
  <modal titulo="Comparação: Dados Extraídos vs Editados" id="odin-comparacao-extracao"
         :fechar="true" @close="close" size="xl">

    <card titulo="Situação Jurídica Atualizada (com base nos dados extraídos originalmente)"
          v-if="comparacaoGeral.length > 0 && dadosOriginais.situacaoJuridica">
      <card-content>
        <div class="texto-minuta mb-2" v-html="dadosOriginais.situacaoJuridica.replaceAll('\n', '<br/>')"></div>
      </card-content>
    </card>

    <card titulo="Dados Gerais do Ato" v-if="comparacaoGeral.length > 0" class="mb-3">
      <card-content>
        <card-table class="table-borderless table-sm">
          <thead>
            <tr class="small">
              <th style="width:200px">Campo</th>
              <th style="width:350px">Extraído pela IA</th>
              <th style="width:350px">Valor Editado</th>
              <th style="width:100px">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in comparacaoGeral" :key="index"
                :class="{'tr-success': item.alterado}">
              <td class="font-weight-bold">{{ item.campo }}</td>
              <td>{{ formatarValor(item.original) }}</td>
              <td>
                <span v-if="item.alterado" class="font-weight-bold text-success">
                  {{ formatarValor(item.editado) }}
                  <i class="fa-solid fa-pen ml-1"></i>
                </span>
                <span v-else class="text-muted">{{ formatarValor(item.editado) }}</span>
              </td>
              <td>
                <span v-if="item.alterado" class="badge badge-success">Editado</span>
                <span v-else class="badge badge-secondary">Original</span>
              </td>
            </tr>
          </tbody>
        </card-table>
      </card-content>
    </card>

    <card titulo="Dados do Indicador Real" v-if="comparacaoIndicadorReal.length > 0" class="mb-3">
      <card-content>
        <card-table class="table-borderless table-sm">
          <thead>
            <tr class="small">
              <th style="width:200px">Campo</th>
              <th style="width:350px">Extraído pela IA</th>
              <th style="width:350px">Valor Editado</th>
              <th style="width:100px">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in comparacaoIndicadorReal" :key="index"
                :class="{'tr-success': item.alterado}">
              <td class="font-weight-bold">{{ item.campo }}</td>
              <td>{{ formatarValor(item.original) }}</td>
              <td>
                <span v-if="item.alterado" class="font-weight-bold text-success">
                  {{ formatarValor(item.editado) }}
                  <i class="fa-solid fa-pen ml-1"></i>
                </span>
                <span v-else class="text-muted">{{ formatarValor(item.editado) }}</span>
              </td>
              <td>
                <span v-if="item.alterado" class="badge badge-success">Editado</span>
                <span v-else class="badge badge-secondary">Original</span>
              </td>
            </tr>
          </tbody>
        </card-table>
      </card-content>
    </card>

    <card titulo="Envolvidos" v-if="comparacaoEnvolvidos.length > 0" class="mb-3">
      <card-content>
        <div v-for="(envolvido, index) in comparacaoEnvolvidos" :key="index" class="mb-4">
          <h6 class="mb-3">
            <i class="fa-solid fa-user mr-2"></i>
            {{ envolvido.nome }}
          </h6>

          <card-table class="table-borderless table-sm">
            <thead>
              <tr class="small">
                <th style="width:200px">Campo</th>
                <th style="width:350px">Extraído pela IA</th>
                <th style="width:350px">Valor Editado</th>
                <th style="width:100px">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(campo, idx) in envolvido.campos" :key="idx"
                  :class="{'tr-success': campo.alterado && !envolvido.removido, 'tr-danger': envolvido.removido}">
                <td class="font-weight-bold">{{ campo.label }}</td>
                <td>{{ formatarValor(campo.original) }}</td>
                <td>
                  <span v-if="envolvido.removido" class="font-weight-bold text-danger">
                    {{ formatarValor(campo.editado) }}
                    <i class="fa-solid fa-trash ml-1"></i>
                  </span>
                  <span v-else-if="campo.alterado" class="font-weight-bold text-success">
                    {{ formatarValor(campo.editado) }}
                    <i class="fa-solid fa-pen ml-1"></i>
                  </span>
                  <span v-else class="text-muted">{{ formatarValor(campo.editado) }}</span>
                </td>
                <td>
                  <span v-if="envolvido.removido" class="badge badge-danger">Removido</span>
                  <span v-else-if="campo.alterado" class="badge badge-success">Editado</span>
                  <span v-else class="badge badge-secondary">Original</span>
                </td>
              </tr>
            </tbody>
          </card-table>
        </div>
      </card-content>
    </card>

    <div class="alert alert-warning" v-if="!temAlteracoes">
      <i class="fa-solid fa-exclamation-triangle mr-2"></i>
      Nenhuma alteração foi detectada. Os dados extraídos pela IA foram mantidos sem modificações.
    </div>

    <template #footer>
      <div class="d-flex w-100 justify-content-between align-items-center">
        <div class="text-muted small">
          <strong>Total de campos alterados:</strong> {{ totalAlteracoes }}
        </div>
        <button type="button" @click.prevent="close()" class="btn btn-secondary">Fechar</button>
      </div>
    </template>
  </modal>
</template>

<script>
import Card from "@/components/Layout/components/Card.vue";
import CardContent from "@/components/Layout/components/CardContent.vue";
import CardTable from "@/components/Layout/components/CardTable.vue";
import Modal from "@/components/Modal.vue";
import FrontBusiness from "@/business/FrontBusiness";

export default {
  name: 'ModalOdinComparacaoExtracao',
  components: {
    Card, CardContent, CardTable, Modal
  },
  props: {
    dadosOriginais: Object,  // Dados extraídos originalmente pela IA
    dadosEditados: Object,   // Dados após edição
  },

  modal: {
    width: 1400
  },

  data() {
    return {
      comparacaoGeral: [],
      comparacaoIndicadorReal: [],
      comparacaoEnvolvidos: [],
    }
  },

  computed: {
    temAlteracoes() {
      return this.totalAlteracoes > 0;
    },

    totalAlteracoes() {
      let total = 0;
      total += this.comparacaoGeral.filter(c => c.alterado).length;
      total += this.comparacaoIndicadorReal.filter(c => c.alterado).length;
      this.comparacaoEnvolvidos.forEach(env => {
        total += env.campos.filter(c => c.alterado).length;
      });
      return total;
    }
  },

  mounted() {
    this.compararDados();
  },

  methods: {
    close() {
      FrontBusiness.closeModal();
    },

    compararDados() {
      this.compararDadosGerais();
      this.compararIndicadorReal();
      this.compararEnvolvidos();
    },

    compararDadosGerais() {
      const original = this.dadosOriginais?.atoMatricula || {};
      const editado = this.dadosEditados?.atoMatricula || {};

      const campos = [
        { key: 'dataAto', campo: 'Data do Ato', formatter: 'date' },
        { key: 'tituloAto', campo: 'Título' },
        { key: 'negocios', campo: 'Negócio Jurídico', formatter: 'array' },
        { key: 'valorTransacao', campo: 'Valor do Negócio/Alienação', formatter: 'currency' },
        { key: 'moedaTransacao', campo: 'Moeda Utilizada' },
        { key: 'dataTransacao', campo: 'Data da Alienação', formatter: 'date' },
        { key: 'criacaoRestricoes', campo: 'Criação de Restrição', formatter: 'array' },
        { key: 'cancelamentoRestricoes', campo: 'Cancelamento de Restrição', formatter: 'array' },
        { key: 'cancelamentoAto', campo: 'Cancelamento de Ato', formatter: 'array' },
      ];

      this.comparacaoGeral = campos
        .filter(c => original[c.key] !== undefined || editado[c.key] !== undefined)
        .map(c => ({
          campo: c.campo,
          original: this.formatarPorTipo(original[c.key], c.formatter),
          editado: this.formatarPorTipo(editado[c.key], c.formatter),
          alterado: !this.valoresIguais(original[c.key], editado[c.key])
        }));
    },

    compararIndicadorReal() {
      const original = this.dadosOriginais?.indicadorReal || {};
      const editado = this.dadosEditados?.indicadorReal || {};

      const campos = [
        { key: 'tipoImovel', campo: 'Tipo de Imóvel' },
        { key: 'numeroUnidade', campo: 'Unidade' },
        { key: 'tipoLogradouro', campo: 'Tipo de Logradouro' },
        { key: 'nomeRua', campo: 'Logradouro (rua)' },
        { key: 'numeroImovel', campo: 'Número' },
        { key: 'complemento', campo: 'Complemento' },
        { key: 'bairro', campo: 'Bairro' },
        { key: 'cidade', campo: 'Cidade' },
        { key: 'estado', campo: 'Estado' },
        { key: 'condominio', campo: 'Empreendimento' },
        { key: 'bloco', campo: 'Bloco' },
        { key: 'loteamento', campo: 'Loteamento' },
        { key: 'lote', campo: 'Lote' },
        { key: 'quadra', campo: 'Quadra' },
        { key: 'fracaoIdeal', campo: 'Fração solo (%)' },
        { key: 'areaPrivativa', campo: 'Área Privativa (m2)' },
        { key: 'areaComum', campo: 'Área Comum (m2)' },
        { key: 'areaAcrescida', campo: 'Área Acrescida' },
        { key: 'areaReduzida', campo: 'Área Reduzida' },
        { key: 'areaTotal', campo: 'Área Total' },
        { key: 'denominacao', campo: 'Denominação' },
        { key: 'zonaImovel', campo: 'Zona do Imóvel' },
        { key: 'unidadeAutonoma', campo: 'Unidade Autônoma', formatter: 'boolean' },
        { key: 'ccir', campo: 'CCIR' },
        { key: 'itrNirf', campo: 'ITR/NIRF' },
        { key: 'car', campo: 'CAR' },
        { key: 'cib', campo: 'CIB' },
        { key: 'cadastroImobiliario', campo: 'Cadastro Imobiliário' },
        { key: 'certificacaoIncra', campo: 'Certificação no SIGEF' },
        { key: 'possuiGeorreferenciamento', campo: 'Possui Georreferenciamento', formatter: 'boolean' },
        { key: 'georreferenciamento', campo: 'Georreferenciamento' },
        { key: 'registroAnterior', campo: 'Registro Anterior' },
        { key: 'confrontantes', campo: 'Especificação e Confrontantes' },
      ];

      this.comparacaoIndicadorReal = campos
        .filter(c => original[c.key] !== undefined || editado[c.key] !== undefined)
        .map(c => ({
          campo: c.campo,
          original: this.formatarPorTipo(original[c.key], c.formatter),
          editado: this.formatarPorTipo(editado[c.key], c.formatter),
          alterado: !this.valoresIguais(original[c.key], editado[c.key])
        }));
    },

    compararEnvolvidos() {
      const originais = this.dadosOriginais?.envolvidos || [];
      const editados = this.dadosEditados?.envolvidos || [];

      const campos = [
        { key: 'nome', label: 'Nome' },
        { key: 'documento', label: 'CPF/CNPJ' },
        { key: 'papel', label: 'Papel', formatter: 'array' },
        { key: 'fracao', label: 'Fração', formatter: 'fraction' },
        { key: 'representanteNome', label: 'Representante' },
        { key: 'representanteCpf', label: 'CPF Representante' },
        { key: 'genero', label: 'Gênero' },
        { key: 'nacionalidade', label: 'Nacionalidade' },
        { key: 'estadoCivil', label: 'Estado Civil' },
        { key: 'profissao', label: 'Profissão' },
        { key: 'rg', label: 'RG' },
        { key: 'nomeConjuge', label: 'Nome do Cônjuge' },
        { key: 'cpfConjuge', label: 'CPF do Cônjuge' },
        { key: 'regimeBens', label: 'Regime de Bens' },
        { key: 'email', label: 'E-mail' },
        { key: 'telefone', label: 'Telefone' },
        { key: 'cep', label: 'CEP' },
        { key: 'logradouro', label: 'Logradouro' },
        { key: 'numero', label: 'Número' },
        { key: 'bairro', label: 'Bairro' },
        { key: 'cidade', label: 'Cidade' },
        { key: 'uf', label: 'UF' },
      ];

      // Processar envolvidos editados ou mantidos
      const envolvidosProcessados = editados.map(editado => {
        // Encontrar o envolvido original correspondente
        const original = originais.find(o =>
          o.nome === editado.nome ||
          (o.documento && editado.documento && o.documento === editado.documento)
        ) || {};

        const camposComparacao = campos
          .filter(c => original[c.key] !== undefined || editado[c.key] !== undefined)
          .map(c => ({
            label: c.label,
            original: this.formatarPorTipo(original[c.key], c.formatter),
            editado: this.formatarPorTipo(editado[c.key], c.formatter),
            alterado: !this.valoresIguais(original[c.key], editado[c.key])
          }));

        return {
          nome: editado.nome || 'Sem nome',
          temAlteracao: camposComparacao.some(c => c.alterado),
          removido: false,
          campos: camposComparacao
        };
      });

      // Processar envolvidos removidos (estavam nos originais mas não estão nos editados)
      const envolvidosRemovidos = originais
        .filter(original => {
          // Verificar se este envolvido original não existe mais nos editados
          return !editados.find(e =>
            e.nome === original.nome ||
            (e.documento && original.documento && e.documento === original.documento)
          );
        })
        .map(original => {
          const camposComparacao = campos
            .filter(c => original[c.key] !== undefined)
            .map(c => ({
              label: c.label,
              original: this.formatarPorTipo(original[c.key], c.formatter),
              editado: '-',
              alterado: true // Sempre marcado como alterado pois foi removido
            }));

          return {
            nome: original.nome || 'Sem nome',
            temAlteracao: true,
            removido: true,
            campos: camposComparacao
          };
        });

      // Combinar envolvidos processados e removidos
      this.comparacaoEnvolvidos = [...envolvidosProcessados, ...envolvidosRemovidos];
    },

    valoresIguais(val1, val2) {
      // Considera null, undefined e string vazia como iguais
      const normalizar = (v) => {
        if (v === null || v === undefined || v === '') return null;
        if (Array.isArray(v)) return v.join(',');
        return String(v);
      };

      return normalizar(val1) === normalizar(val2);
    },

    formatarPorTipo(valor, tipo) {
      if (valor === null || valor === undefined || valor === '') {
        return '-';
      }

      switch (tipo) {
        case 'date':
          return this.$formatters.date(valor);
        case 'currency':
          return this.$formatters.currency(valor, 2);
        case 'array':
          return Array.isArray(valor) ? valor.join(', ') : valor;
        case 'boolean':
          return valor === true || valor === 1 || valor === '1' ? 'Sim' : 'Não';
        case 'fraction':
          return this.$formatters.currency(valor, { min: 2, max: 10 });
        default:
          return valor;
      }
    },

    formatarValor(valor) {
      if (valor === null || valor === undefined || valor === '') {
        return '-';
      }
      return valor;
    }
  }
}
</script>

<style scoped lang="scss">
.tr-success {
  background-color: rgba(40, 167, 69, 0.1) !important;
}

.tr-danger {
  background-color: rgba(220, 53, 69, 0.1) !important;
}

.badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}
</style>
